/**
 * Modal open/close action (replaces MaterializeAction for modal usage).
 * Compatible with: emit({ action: 'modal', params: ['open'] }) or params: ['close'].
 */
export interface ModalAction {
  action: string;
  params: string[];
}